import addonContentObservable from './addonContentObservable';
import addonPromoObservable from './addonPromoObservable';
import { merge } from 'rxjs';

function addonObservable(addonId: string, planId?: string, title?: string) {
  return merge(
    addonPromoObservable(addonId),
    addonContentObservable(addonId, planId, title)
  );
}

export default addonObservable;
